import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye } from '@fortawesome/free-solid-svg-icons'

export const CompanyMasterPopup = (props) => {
    return (
        <ModalBasic
            id="companyMaster"
            classParams="!w-[75%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Company information</span>
                <div className='item-grp grid grid-cols-2 mt-2.5 mb-3 pb-3 border-b border-slate-300'>
                    <div className='input-grp'>
                        <label>Company name:</label>
                        <TextInput type='text'
                            id='companyName' name='companyName'
                            value={props.companyObject.companyName}
                            handleChange={(event) => props.handleChange(event, 'companyName')}
                            className={props.validState?.error?.companyName !== undefined ? "error" : ""}
                        />
                    </div>
                </div>

                <span className="text-blue text-[16px] font-semibold">Other information</span>
                <div className='item-grp grid grid-cols-2 mt-2 mb-2.5'>
                    <div className='input-grp'>
                        <label>Address:</label>
                        <textarea rows={2} type='text'
                            id='office_Address' name='office_Address'
                            value={props.companyObject.office_Address}
                            onChange={(event) => props.handleChange(event, 'office_Address')}
                            className={props.validState?.error?.office_Address !== undefined ? "error" : ""}

                        />
                    </div>
                </div>
                <div className='item-grp grid grid-cols-4 gap-x-2.5 gap-y-3 mb-3 pb-3 border-b border-slate-300'>
                    <div className='input-grp'>
                        <label>City name:</label>
                        <TextInput type='text'
                            id='cityName' name='cityName'
                            value={props.companyObject.cityName}
                            handleChange={(event) => props.handleChange(event, 'cityName')}
                            className={props.validState?.error?.cityName !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>State code:</label>
                        <TextInput type='number'
                            id='stateCode' name='stateCode'
                            value={props.companyObject.stateCode}
                            handleChange={(event) => props.handleChange(event, 'stateCode')}
                            className={props.validState?.error?.stateCode !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>PIN code:</label>
                        <TextInput type='number'
                            id='pincode' name='pincode'
                            value={props.companyObject.pincode}
                            handleChange={(event) => props.handleChange(event, 'pincode')}
                            className={props.validState?.error?.pincode !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Contact no:</label>
                        <TextInput type='text'
                            id='contactNo' name='contactNo'
                            value={props.companyObject.contactNo}
                            handleChange={(event) => props.handleChange(event, 'contactNo')}
                            className={props.validState?.error?.contactNo !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>OTP mobile no:</label>
                        <TextInput type='test'
                            id='otpMobNo' name='otpMobNo'
                            value={props.companyObject.otpMobNo}
                            handleChange={(event) => props.handleChange(event, 'otpMobNo')}
                            className={props.validState?.error?.otpMobNo !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Phone no:</label>
                        <TextInput type='text'
                            id='phoneNo' name='phoneNo'
                            value={props.companyObject.phoneNo}
                            handleChange={(event) => props.handleChange(event, 'phoneNo')}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Email id:</label>
                        <TextInput type='text'
                            id='comp_EmailID' name='comp_EmailID'
                            value={props.companyObject.comp_EmailID}
                            handleChange={(event) => props.handleChange(event, 'comp_EmailID')}
                            className={props.validState?.error?.comp_EmailID !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Fax no:</label>
                        <TextInput type='number'
                            id='faxNo' name='faxNo'
                            value={props.companyObject.faxNo}
                            handleChange={(event) => props.handleChange(event, 'faxNo')}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Website:</label>
                        <TextInput type='text'
                            id='website' name='website'
                            value={props.companyObject.website}
                            handleChange={(event) => props.handleChange(event, 'website')}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>PAN no:</label>
                        <TextInput type='text'
                            id='panNo' name='panNo'
                            value={props.companyObject.panNo}
                            handleChange={(event) => props.handleChange(event, 'panNo')}
                            className={props.validState?.error?.panNo !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>GST no:</label>
                        <TextInput type='text'
                            id='gstNo' name='gstNo'
                            value={props.companyObject.gstNo}
                            handleChange={(event) => props.handleChange(event, 'gstNo')}
                            className={props.validState?.error?.gstNo !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>GST date:</label>
                        <TextInput type='date'
                            id='gstDate' name='gstDate'
                            value={props.companyObject.gstDate}
                            handleChange={(event) => props.handleChange(event, 'gstDate')}
                            className={props.validState?.error?.gstDate !== undefined ? "error" : ""}
                        />
                    </div>
                </div>

                <span className="text-blue text-[16px] font-semibold">Company logo & sign:</span>
                <div className='item-grp grid grid-cols-4 gap-2.5 mt-3'>
                    <div className='input-grp relative'>
                        <form className="input-grp w-full">
                            <label
                                htmlFor="upload_Logo"
                            // className="text-uplod block text-sm text-[#757575]"
                            >
                                Select logo
                            </label>
                            {/* <img
                                className="uplod-svg inline-flex w-5 h-5 fill-[#757575] ml-4"
                                src="/pdf-upload.svg"
                                alt=""
                              ></img> */}
                            <input
                                className="!pr-[35px]"
                                id="upload_Logo"
                                type="file"
                                // onBlur={() => props.validateField("report")}
                                onChange={(event) => props.onFileChange(event, 'Logo')}
                            />
                        </form>
                        {props.companyObject.logoFileName ?
                            <button
                                className="w-[20px] h-[20px] flex absolute bottom-[15%] right-[3%]"
                                onClick={() =>
                                    props.getFiles(
                                        "Logo",
                                        props.companyObject.logoFileName
                                    )
                                }
                            >
                                <FontAwesomeIcon icon={faEye} className="text-[#e78e3c] " title="View file"/>
                                {/* <span className="text-xl text-[#e78e3c]">
                                    View Files
                                </span> */}
                            </button>
                            :
                            null
                        }
                    </div>
                    <div className='input-grp relative'>
                        {/* <label
                        //htmlFor={`default`}
                        >Select sign:</label> */}
                        {/* <TextInput type='file'
                            id='selectSign' name='selectSign'
                            //value={props.companyObject.signFileName}
                            //handleChange={(event) => props.handleChange(event, 'selectSign')}
                            handleChange={(event) => props.onFileChange(event, 'Sign')}
                        /> */}
                        <form className="input-grp w-full">
                            <label
                                htmlFor="upload_Sign"
                            // className="text-uplod block text-sm text-[#757575]"
                            >
                                Select sign
                            </label>
                            {/* <img
                                className="uplod-svg inline-flex w-5 h-5 fill-[#757575] ml-4"
                                src="/pdf-upload.svg"
                                alt=""
                              ></img> */}
                            <input
                                className="!pr-[35px]"
                                id="upload_Sign"
                                type="file"
                                // onBlur={() => props.validateField("report")}
                                onChange={(event) => props.onFileChange(event, 'Sign')}
                            />
                        </form>
                        {props.companyObject.signFileName ?
                            <button
                                className="w-[20px] h-[20px] flex absolute bottom-[15%] right-[3%]"
                                onClick={() =>
                                    props.getFiles(
                                        "Sign",
                                        props.companyObject.signFileName
                                    )
                                }
                            >
                                <FontAwesomeIcon icon={faEye} className="text-[#e78e3c]" title="View file"/>
                                {/* <span className="text-xl text-[#e78e3c]">
                                    View Files
                                </span> */}
                            </button>
                            :
                            null
                        }

                    </div>
                    <div className='input-grp relative'>
                        {/* <label
                        //htmlFor={`default`}
                        >Select header:</label>
                        <TextInput type='file'
                            id='selectHeader' name='selectHeader'
                            //value={props.companyObject.headerImage}
                            //handleChange={(event) => props.handleChange(event, 'selectHeader')}
                            handleChange={(event) => props.onFileChange(event, 'Header')}
                        /> */}
                        <form className="input-grp w-full">
                            <label
                                htmlFor="upload_Header"
                            // className="text-uplod block text-sm text-[#757575]"
                            >
                                Select header
                            </label>
                            {/* <img
                                className="uplod-svg inline-flex w-5 h-5 fill-[#757575] ml-4"
                                src="/pdf-upload.svg"
                                alt=""
                              ></img> */}
                            <input
                                className="!pr-[35px]"
                                id="upload_Header"
                                type="file"
                                // onBlur={() => props.validateField("report")}
                                onChange={(event) => props.onFileChange(event, 'Header')}
                            />
                        </form>
                        {props.companyObject.headerImage ?
                            <button
                                className="w-[20px] h-[20px] flex absolute bottom-[15%] right-[3%]"
                                onClick={() =>
                                    props.getFiles(
                                        "Header",
                                        props.companyObject.headerImage
                                    )
                                }
                            >
                                <FontAwesomeIcon icon={faEye} className="text-[#e78e3c]" title="View file"/>
                                {/* <span className="text-xl ">
                                    View Files
                                </span> */}
                            </button>
                            :
                            null
                        }
                    </div>
                    <div className='input-grp'>
                        <label
                            htmlFor={`default`}
                        >Select date:</label>
                        <TextInput type='date'
                            id='selectDate' name='selectDate'
                            //value={props.companyObject.selectDate}
                            handleChange={(event) => props.handleChange(event, 'selectDate')}
                        />

                    </div>
                </div>
                <div className='btn-grp flex justify-between mt-5'>
                    <div className='btn-left flex gap-2.5'>
                        <button className="update-btn btns" onClick={() => props.submit()}> Update </button>
                        <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                    </div>
                    <div className="btn-right flex gap-2.5">
                        <button className="edit-btn btns" onClick={() => props.usp_Master_ItemStockTransferNewYear()} >Transfer stock</button>
                        <button className="edit-btn btns" onClick={() => props.usp_Master_PartyBalanceTransferNewYear()} >Transfer party balance</button>
                        <button className="edit-btn btns" onClick={() => props.usp_Master_BankClosingTransferNewYear()} >Transfer bank closing</button>
                        <button className="edit-btn btns" onClick={() => props.usp_TruncateAllRecords()} >Start new year</button>
                    </div>
                </div>
            </div>

        </ModalBasic>
    )
}
